import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedStage } from '../../Reducers/Configurator/Actions';
import { DESIGN, MATERIAL, PRODUCT } from '../../Constants/Steps';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  linkText: {
    fontStyle: 'italic',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
});

export const BackStepLink = () => {
  const dispatch = useDispatch();
  const { selectedStage } = useSelector((state) => state.configurator);
  const classes = useStyles();
  if (selectedStage === PRODUCT) {
    return <span />;
  }
  return (
    <Typography
      variant="body1"
      component="span"
      className={classes.linkText}
      onClick={() =>
        selectedStage === MATERIAL ? dispatch(setSelectedStage(DESIGN)) : dispatch(setSelectedStage(PRODUCT))
      }
    >
      {selectedStage === MATERIAL ? t('backToDesign') : t('backToProduct')}
    </Typography>
  );
};

BackStepLink.propTypes = {
  selectedStage: PropTypes.string,
};

export default BackStepLink;
